module.exports = __webpack_public_path__ + "h5/img/lvka_footer.6a839bd3.png";